import { SIMPLVmTable } from "../../SimplVmTable";

export const SIMPLVmConfiguration = () => (
  <SIMPLVmTable
    type="vm-configuration"
    addButtonLabel="Add Config"
    addModalTitle="VM Configuration"
    contentLabel="Cloud Init"
    contentMessage="Cloud Init is required"
  />
);